import { useReducer } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import BookingPage from "./Booking";
import HomePage from "./Home";
import { fetchAPI, submitAPI } from "../../utils/api";
import ConfirmedBooking from "./ConfirmedBooking";
import ComingSoon from "./ComingSoon";

export function updateTimes(state, action) {
  switch (action.type) {
    // Check if the dispatch's action is FETCH_TIMES
    case "FETCH_TIMES":
      // Check if there's no payload
      if (!action.payload) return state;

      // Check if API available
      if (window.fetchAPI) {
        console.log("(updateTimes) Fetching Time...");
        return window.fetchAPI(new Date(action.payload));
      }

      // Fallback if API fails
      console.log("(updateTimes) Fetching Time via local API...");
      return fetchAPI(new Date(action.payload));

    default:
      return state;
  }
}

export function initializeTimes() {
  // Get today's date
  const today = new Date();

  // Check if API available
  if (window.fetchAPI) {
    console.log("(initializeTimes) Fetching Date...");
    return window.fetchAPI(today);
  }

  // Fallback if API fails
  console.log("(initializeTimes) Fetching Time via local API...");
  return fetchAPI(today);
}

export default function Main() {
  // Initialize the state using useReducer hook
  const [availableTimes, dispatch] = useReducer(
    updateTimes,
    [],
    initializeTimes,
  );

  // Initialize the navigate function
  const navigate = useNavigate();

  // Handle the submit form
  const submitForm = (formData) => {
    // Set default response to false
    let res = false;

    // Check if API available
    if (window.submitAPI) {
      console.log("(submitForm) Submitting Form...");
      res = window.submitAPI(formData);
    } else {
      // Fallback if API fails
      console.log("(submitForm) Submitting Form via local API...");
      res = submitAPI(formData);
    }

    // Check if response is success
    if (res) {
      navigate("/confirmed");
    } else {
      return res;
    }
  };

  return (
    <main>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<ComingSoon />} />
        <Route path="/menu" element={<ComingSoon />} />
        <Route
          path="/booking"
          element={
            <BookingPage
              availableTimes={availableTimes}
              dispatch={dispatch}
              submitForm={submitForm}
            />
          }
        />
        <Route path="/confirmed" element={<ConfirmedBooking />} />
        <Route path="/order" element={<ComingSoon />} />
        <Route path="/login" element={<ComingSoon />} />
      </Routes>
    </main>
  );
}
